import { Component } from '@angular/core';

import { StorageService } from './services/StorageService';
// import { TranslateService } from '@ngx-translate/core';
// import Swal from 'sweetalert2';
// import { UpToDateBuildService } from './helpers/BuildDetails/up-to-date.service';
import { Directionality } from '@angular/cdk/bidi';
import packageJson from '../../package.json';
import { Title } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'BonTech - Restaurant App Management';
  public version: string = packageJson.version;
  styleReady = false;

  constructor(
    public storageService: StorageService,
    // private translate: TranslateService,
    private titleService: Title,
    private appDir: Directionality,
    private dialog: MatDialog
    // upToDateService: UpToDateBuildService
  ) {
    // let buildNumber = upToDateService.buildNumberAtStartup;
    // upToDateService.buildIsUpToDate.subscribe(buildIsUpToDate => {
    //   if (!buildIsUpToDate) {
    //     Swal.fire({
    //       title: this.translate.instant('general.New app version found.'),
    //       icon: 'info',
    //       confirmButtonText: this.translate.instant('swalMsg.Reload'),
    //     }).then(() => {
    //       window.location.reload();
    //     });
    //   }
    // });

    this.storageService.changes.subscribe(data => {
      if (data?.key == 'language' || data?.key == 'authUser') {
        localStorage.removeItem('orders');
        localStorage.removeItem('takeawarOrder');
        window.location.reload();
      }
    });

    var lang = localStorage.getItem('language') || 'en';
    this.title = lang === 'ar' ? 'بون تك - تطبيق إدارة المطاعم' : 'BonTech - Restaurant Management App';
    this.titleService.setTitle(this.title);

    localStorage.setItem('language', lang);
    var style = './assets/css/en-US/style.css';
    var dir = 'ltr';
    if (lang == 'ar') {
      style = './assets/css/ar-SA/style.css';
      dir = 'rtl';
    }
    let buildNumber = this.version;
    style += buildNumber ? '?vr=' + buildNumber : '';
    // document.getElementById('mainStyle')?.setAttribute('href', style);
    document.getElementById('html')?.setAttribute('lang', lang);
    document.getElementById('html')?.setAttribute('dir', dir);
    (this.appDir as any).value = dir;


    this.waitForStylesheet(style)
      .then(() => {
        this.styleReady = true;
      })
      .catch(err => {
        console.error(err);
        this.styleReady = true;
      });

    // Listen for ALL dialogs opening
    this.dialog.afterOpened.subscribe(() => {
      const dialogRef = this.dialog.openDialogs[this.dialog.openDialogs.length - 1];

      if (!dialogRef) return;

      // Listen for backdrop click
      dialogRef.backdropClick().subscribe(() => {
        this.triggerCloseButton(dialogRef);
      });
    });
  }

  private triggerCloseButton(dialogRef: any) {
    // Try to find ANY close button inside dialog
    const container = document.querySelector('.mat-dialog-container');

    if (!container) {
      // dialogRef.close();
      return;
    }

    // Common close button patterns
    const selectors = [
      'button[mat-dialog-close]',
      'button[matdialogclose]',
      '.close, .close-btn'
    ]; ``

    for (const sel of selectors) {
      const btn = container.querySelector(sel);
      if (btn) {
        (btn as HTMLElement).click();
        return;
      }
    }

    // Fallback if no button found
    // dialogRef.close();
  }

  waitForStylesheet(href: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const links = Array.from(document.styleSheets)
        .map(s => (s as CSSStyleSheet).href)
        .filter(Boolean);
      if (links.includes(location.origin + '/' + href)) {
        resolve();
      } else {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        link.onload = () => resolve();
        link.onerror = () => reject(`Stylesheet failed to load: ${href}`);
        document.head.appendChild(link);
      }
    });
  }
}
